export default "__VITE_ASSET__CcvnxPN___ 400w, __VITE_ASSET__BB6H_YLm__ 800w, __VITE_ASSET__CqpMwVEQ__ 1024w";